<div class="login">
    <img
        class="img-fluid branding-img"
        src="{{ assetPath }}LAS.png"
        alt="LAS branding"
    />
</div>
